import { IsUUID, IsOptional } from "class-validator";
import { PaginatedRequest } from "../../../common/paginated-request/paginated-request.dto";

export class GetAdminUsersRequest extends PaginatedRequest {
    @IsUUID()
    @IsOptional()
    accountId?: string;
}